import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { PlusMinusButton } from './CounterStyle'
import { Black, CenterVertical } from './GeneralStyle'

class Counter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      count: this.props.count
    };
    this.incrementCount = this.incrementCount.bind(this)
    this.decrementCount = this.decrementCount.bind(this)
  }

  incrementCount() {
    if (this.state.count < this.props.maxCount) {
      const countTemp = this.state.count + 1
      this.setState({
        count: countTemp
      });

      this.props.setCount(countTemp)
    }
  }

  decrementCount() {
    if (this.state.count > 1) {
      const countTemp = this.state.count - 1
      this.setState({
        count: countTemp
      });

      this.props.setCount(countTemp)
    }
  }

  render() {
    return (
      <Grid
        fluid>
        <Row className={"row-eq-height"}>
          <Col sm={4} md={4} lg={4} >
            <PlusMinusButton
              disabled={this.state.count === 1}
              onClick={this.decrementCount}>-</PlusMinusButton>
          </Col>
          <Col sm={4} md={4} lg={4} >
            <CenterVertical><Black style={{fontSize: 16}} >{this.state.count}</Black></CenterVertical>
          </Col>
          <Col sm={4} md={4} lg={4} >
            <PlusMinusButton
              disabled={this.state.count === this.props.maxCount}
              onClick={this.incrementCount}>+</PlusMinusButton>
          </Col>
        </Row>
      </Grid>
    )
  }
}

Counter.propTypes = {
  sendData: PropTypes.func,
  count: PropTypes.number
};

export default Counter;



// WEBPACK FOOTER //
// /src/components/Counter.js